import { FC, useEffect, useRef, useState } from 'react';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import { Form } from 'react-bootstrap';
import { DownChevron } from './OrgProvidersMultiSelect';

type Option = { value: string; label: string };

type Props = {
  options: Array<Option>;
  selectedValues: string[];
  onChange?: (newSelectedValues: string[]) => void;
  className?: string;
  classNamePrefix?: string;
  disabled?: boolean;
  placeholder?: string;
};

const ClientMultiSelect: FC<Props> = (props) => {
  const [selected, setSelected] = useState(props.selectedValues);
  const [search, setSearch] = useState('');
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    MenuComponent.reinitialization();
  }, []);

  useEffect(() => {
    setSelected(props.selectedValues);
  }, [props.selectedValues]);

  const selectedLabels = props.options
    .filter((o) => selected.includes(o.value))
    .map((o) => o.label);

  const closeMenu = () => {
    MenuComponent.hideDropdowns(undefined);
  };

  const handleNameClick = (value: string) => {
    props.onChange?.([value]);
    closeMenu();
  };

  const prefix = props.classNamePrefix || 'clientMultiSelect';

  return (
    <div className={`${props.className} multi-select-container`}>
      <div
        className={`${prefix}__control multi-select-control`}
        data-kt-menu-trigger="click"
        data-kt-menu-placement="bottom-start"
      >
        <div
          className={`${prefix}__value-container ${prefix}__value-container--has-value multi-select-value-container`}
        >
          <div
            className={`${prefix}__single-value multi-select-single-value me-2`}
            style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          >
            {selected.length === 0 ? (
              <span className="text-gray-500">{props.placeholder ?? 'Select client...'}</span>
            ) : selected.length === 1 ? (
              selectedLabels[0]
            ) : (
              `${selected.length} Clients selected: ${selectedLabels.join(', ')}`
            )}
          </div>
        </div>
        <div className={`${prefix}__indicators multi-select-indicators-container`}>
          <span className={`${prefix}__indicator-separator multi-select-indicator-separator`}></span>
          <div
            className={`${prefix}__indicator ${prefix}__dropdown-indicator multi-select-indicator-container`}
            aria-hidden="true"
          >
            <DownChevron />
          </div>
        </div>
      </div>
      <div
        ref={menuRef}
        className={`${prefix}__menu multi-select-menu menu menu-sub menu-sub-dropdown menu-column menu-gray-600 menu-state-bg-light-primary w-auto fw-bold fs-7 py-5`}
        style={{ overflowY: 'auto', maxHeight: '500px' }}
        data-kt-menu="true"
      >
        <div className="d-flex">
          <h6 className="me-auto ms-10 text-gray-600">Clients</h6>
          <h6
            onClick={() => {
              props.onChange?.([]);
            }}
            className="me-10 text-primary pb-1 cursor-pointer fw-lighter"
          >
            Clear
          </h6>
        </div>
        <div className="mx-10 mb-3">
          <input
            type="text"
            className="form-control form-control-sm form-control-solid"
            placeholder="Search clients..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
        </div>
        {props.options?.filter((o) => !search || o.label.toLowerCase().includes(search.toLowerCase())).map((o) => (
          <div key={o.value} className="mx-10 my-3 d-flex align-items-center">
            <Form.Check
              name="client-multi-select"
              type="checkbox"
              id={`client-${o.value}`}
              className="my-0 multi-select-input me-2 flex-shrink-0"
              checked={selected.includes(o.value)}
              onChange={(e) => {
                if (e.target.checked) {
                  if (!selected.includes(o.value)) props.onChange?.([...selected, o.value]);
                } else {
                  props.onChange?.(selected.filter((s) => s !== o.value));
                }
              }}
            />
            <span
              className="cursor-pointer text-hover-primary flex-grow-1"
              onClick={() => handleNameClick(o.value)}
            >
              {o.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export { ClientMultiSelect };
